// Detect outside click of an element

function nodeContainsId(el, id) {
    if (el.id === id) {
        return true;
    }

    let current = el.parentNode;

    while (current && current !== document) {
        if (current.id === id) {
            return true;
        }
        current = current.parentNode;
    }

    return false;
}

// callbackFunction: called when click outside
// triggerId: element triggering the dropdown
export const clickOutside = (callbackFunction, triggerId) => {
    return (element) => {
        function onClick(event) {
            let isTriggerClick = false;
            if (nodeContainsId(event.target, triggerId)) {
                isTriggerClick = true;
            }

            if (!element.contains(event.target) && !isTriggerClick) {
                callbackFunction(event.target);
            }
        }

        document.body.addEventListener('click', onClick);

        return () => {
            document.body.removeEventListener('click', onClick);
        };
    };
};
